import axios from '@axios'

const DEALS_PREFIX = '/deals'

export default {
  // Legacy / Portuguese-named helpers (kept for compatibility)
  getDealDocumentos(dealId) {
    return axios.get(`${DEALS_PREFIX}/${dealId}/documentos`)
  },
  createDealDocumento(dealId, formData) {
    return axios.post(`${DEALS_PREFIX}/${dealId}/documentos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  // New / English-named helpers that match the backend routes
  getDealDocuments(dealId) {
    return axios.get(`${DEALS_PREFIX}/${dealId}/documents`)
  },

  createDealDocument(dealId, formData) {
    return axios.post(`${DEALS_PREFIX}/${dealId}/documents`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  updateDocument(dto) {
    return axios.put(`${DEALS_PREFIX}/documents`, dto)
  },

  getDocumentDownloadUrl(id) {
    return axios.get(`${DEALS_PREFIX}/documents/${id}/download`)
  },

  deleteDocument(id) {
    return axios.delete(`${DEALS_PREFIX}/documents/${id}`)
  },
}
